// src/components/support/forms/TakeBreak.js
import React, { useState } from "react";
import { ChevronDown, ChevronLeft } from "lucide-react";
import { useRequestProcessor } from "../../../requestProcessor";

import SpinnerLoading from "../../common/SpinnerLoading";
import { handleTakeABreak } from "../../../queryfunctions/queryfunctions";
import { useAtom } from "jotai";
import { childList } from "../../../atomstore/store";
import FootprintDatePicker from "../../common/FootprintDatePicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../common/CustomSelect";

const TakeBreak = () => {
    const navigate = useNavigate();
    const { useMutationWrapper } = useRequestProcessor();
    const [children] = useAtom(childList)
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [reason, setReason] = useState("");
    const [error, setError] = useState("");
    const [selectedChild, setSelectedChild] = useState(0)
    const isRestrictionActive = false

    const takeABreak = useMutationWrapper(
        ["takeABreak"],
        () => {
            console.log("[Take a break] API Request:", { fromDate, toDate, reason });
            return handleTakeABreak(fromDate, toDate, reason, children[selectedChild]);
        },
        {
            onSuccess: (data) => {
                console.log("[Take a break] API Success:", data);
            },
        }
    );

    console.log("Selected Child", children[selectedChild])
    const validate = () => {
        if (!fromDate) {
            setError("Please select From Date");
            return false;
        } else if (!toDate) {
            setError("Please select To Date");
            return false;
        } else if (isRestrictionActive &&
            fromDate &&
            toDate &&
            moment(toDate).diff(moment(fromDate), "days") > 30
        ) {
            setError("Break duration cannot exceed 30 days");
            return false;
        } else if (!reason.trim()) {
            setError("Please enter a reason");
            return false;
        }
        setError("");
        return true;
    };

    const submitRequest = () => {
        if (validate()) {
            console.log("[Take a break] Submitting form:", { fromDate, toDate, reason });
            takeABreak.mutate();
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {takeABreak.isLoading && <SpinnerLoading />}

            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Take a Break</h2>
            </div>

            <div className="p-4 space-y-4">
                {children.length > 1 && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Select Child
                        </label>

                        <CustomSelect
                            label="Select Child"
                            value={selectedChild}
                            onChange={(val) => setSelectedChild(Number(val))}
                            options={children.map((child, idx) => ({
                                value: idx,
                                label: `${child?.name} ${child?.last_name}`,
                            }))}
                        />
                    </div>
                )}

                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg">
                    <p className="text-sm text-blue-800">
                        Pause services temporarily for{" "}
                        {children[selectedChild]?.name.split(" ")[0]}. You won't be charged
                        during this period.
                    </p>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        From Date
                    </label>
                    {/* <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500"
                    /> */}
                    <FootprintDatePicker
                        onChange={(date) => {
                            setFromDate(moment(date));
                            setError("");
                        }}
                        minimumDate={moment()}
                        inputProps={{
                            placeholder: "Select Date",
                        }}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        To Date
                    </label>
                    <FootprintDatePicker
                        onChange={(date) => {
                            setToDate(moment(date));
                            setError("");
                        }}
                        minimumDate={fromDate || moment()}
                        maximumDate={
                            isRestrictionActive && fromDate
                                ? fromDate.clone().add(30, "days")
                                : null
                        }
                        placeholder="Select Date"
                        disabled={!fromDate}
                        inputProps={{
                            disabled: !fromDate,
                            placeholder: "Select Date",
                        }}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Reason
                    </label>
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Please share the reason for the break..."
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500 h-32 outline-none focus:border-transparent"
                    />
                </div>

                {error && <p className="text-red-500 text-sm">{error}</p>}

                <button
                    onClick={submitRequest}
                    disabled={takeABreak.isLoading}
                    className="w-full bg-cyan-500 text-white py-3 rounded-xl font-semibold hover:bg-cyan-600 transition disabled:opacity-60"
                >
                    Submit Request
                </button>
            </div>
        </div>
    );
};

export default TakeBreak;
